import React from "react";

export default function MySQL_TRIM() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_TRIM</h1>
      <p>This is the MySQL_TRIM component generated from the SQL JSON.</p>
    </div>
  );
}
